import {
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { fetchUtils } from "react-admin";

interface ForgotPasswordProps {
  setIsForgotPassword: (value: boolean) => void;
}

const ForgotPassword = ({ setIsForgotPassword }: ForgotPasswordProps) => {
  const [emailForgot, setEmailForgot] = useState("");
  const [isSuccessSentEmail, setIsSuccessSentEmail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // 🔴 error snackbar
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorOpen, setIsErrorOpen] = useState(false);

  const apiUrl = process.env.REACT_APP_API_HOST;
  const httpClient = fetchUtils.fetchJson;

  const validateEmail = (email: string) => {
    if (!email) {
      return "Email is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Invalid email format";
    }

    return "";
  };

  const _onSubmitForgot = (e?: React.FormEvent) => {
    e?.preventDefault();

    const error = validateEmail(emailForgot);

    // 🔴 show validation error via snackbar
    if (error) {
      setErrorMessage(error);
      setIsErrorOpen(true);
      return;
    }

    setIsLoading(true);

    httpClient(`${apiUrl}/api/ForgotPassword`, {
      method: "POST",
      body: JSON.stringify({ email: emailForgot, type: "superadmin", }),
    })
      .then(() => {
        setIsSuccessSentEmail(true);
        setIsLoading(false);
      })
      .catch(() => {
        // security: still show success message
        setIsSuccessSentEmail(true);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div style={{ fontSize: "24px", fontWeight: 500 }}>Forgot Password</div>

      <div style={{ width: "60%", marginTop: "20px" }}>
        <form onSubmit={_onSubmitForgot} noValidate>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2.25rem",
            }}
          >
            <div style={{ fontSize: "15px" }}>
              Enter your email address to receive a password reset link.
            </div>

            <TextField
              value={emailForgot}
              onChange={(e) => setEmailForgot(e.target.value)}
              fullWidth
              label="Email"
              variant="filled"
              size="small"
            />

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.25rem",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                fullWidth
                style={{
                  backgroundColor: "#2b6cb0",
                  color: "#fff",
                  marginLeft: "0px",
                }}
              >
                {isLoading ? (
                  <CircularProgress size={25} color="inherit" />
                ) : (
                  "Send Reset Email"
                )}
              </Button>

              <Button
                variant="text"
                style={{ color: "#555", margin: "auto" }}
                onClick={() => {
                  setIsForgotPassword(false);
                  setIsSuccessSentEmail(false);
                }}
              >
                Have an account? Sign in
              </Button>
            </Box>
          </div>
        </form>

        {/* ✅ SUCCESS SNACKBAR */}
        <Snackbar
          open={isSuccessSentEmail}
          autoHideDuration={5000}
          onClose={() => setIsSuccessSentEmail(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity="success"
            variant="filled"
            onClose={() => setIsSuccessSentEmail(false)}
          >
            If your email is valid, a reset password instruction has been sent
            to you.
          </Alert>
        </Snackbar>

        {/* 🔴 ERROR SNACKBAR */}
        <Snackbar
          open={isErrorOpen}
          autoHideDuration={4000}
          onClose={() => setIsErrorOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity="error"
            variant="filled"
            onClose={() => setIsErrorOpen(false)}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default ForgotPassword;
